import type { Visualize3dComponent } from './visualize3d-component';
import { Matrix4x4, createIdentityMatrix } from '../models/math/matrix4x4';
import type { Visualize3dComponentCreator } from './visualize3d-component-creator';

export interface TransformComponent extends Visualize3dComponent {
  matrix: Matrix4x4;
}

export const transformComponentCreator: Visualize3dComponentCreator<TransformComponent> = {
  createComponent: createTransformComponent,
};

export function createTransformComponent(): TransformComponent {
  return {
    $type: 'MagiCADCore.Visualize3D.DataTransfer.TransformDto, MagiCADCore.Visualize3D',
    type: 'Transform',
    matrix: createIdentityMatrix(),
  };
}
